import { useMutation } from "@tanstack/react-query";
import fetchApi from "../fetchApi";

interface PricePayload {
  amount: number | string;
  corporate_subsidiary_id: number | string;
  payment_method_id: number | string;
  corporate_service_id: number | string;
}

export interface PriceResponse {
  amount: string;
  total_fees: string;
  total_amount: string;
  calculated_at: string | null;
}

function objectToKeyValueString(obj: Record<string, any>): string {
  return `?${Object.entries(obj)
    .map(([key, value]) => `${key}=${value}`)
    .join("&")}`;
}

export const usePriceMutation = ({ authorisation = "" }) => {
  return useMutation(async (payload: PricePayload) => {
    const response: PriceResponse = await fetchApi("payment/price", {
      headers: {
        Authorization: `Bearer ${authorisation}`,
      },
    }).get(objectToKeyValueString(payload));

    return response;
  });
};
